<script>
  export let color = '#5373F0';
</script>

<svg
  width="30"
  height="42"
  viewBox="0 0 30 42"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M29.5834 41.2563V16.8334V14.7501V4.33342C29.5834 2.03341 27.7167 0.166748 25.4167 0.166748H4.58342C2.28341 0.166748 0.416748 2.03341 0.416748 4.33342V14.7501V16.8334V41.2563L15.0001 31.7334L29.5834 41.2563ZM6.66675 12.6667L12.223 11.973L15.0001 6.41675L17.7772 11.973L23.3334 12.6667L18.7022 16.6022L20.5563 23.0834L15.0001 19.3792L9.44383 23.0834L11.298 16.6022L6.66675 12.6667Z"
    fill={color}
  />
</svg>
